// TODO: Manage generic criterias instead of specific ones (zones, agence, caterogies...)
// import { getCriteres } from '../../../api/criteresForfaitsTransport' TODO FACTORING BY CRITERES

import * as types from './mutation-types'
import {
  getForfaitsTransport,
  postForfaitTransport,
  deleteForfaitTransport
} from '../../../api/forfaitTransport'
import { getZones } from '../../../api/zone'
import { getRootCategories } from '../../../api/planVente'
import { getTranches, postTranche } from '../../../api/tranche'
import * as constants from '../modal/modal-constants'

const getInitialState = () => {
  return {
    forfaitsTransport: null,
    zonesOptions: null,
    categoriesOptions: null,
    tranchesOptions: null,
    currentForfaitTransport: {
      agence: {
        code_agence: null,
        libelle_agence: null
      },
      zone: {
        id: null,
        libelle: null
      },
      categorie: {
        id: null,
        libelle: null
      },
      tranche: {
        id: null,
        libelle: null,
        debut: null
      },
      montant: null,
      franco: null
    },
    trancheSelected: null
  }
}

const state = { ...getInitialState() }

const mutations = {
  [types.SET_FORFAITS_TRANSPORT](state, {
    forfaitsTransport,
    zonesOptions,
    categoriesOptions,
    tranchesOptions
  }) {
    state.forfaitsTransport = forfaitsTransport
    state.zonesOptions = zonesOptions
    state.categoriesOptions = categoriesOptions
    state.tranchesOptions = tranchesOptions
  },
  [types.SET_TRANCHE_FORFAIT_TRANSPORT](state, tranche) {
    state.currentForfaitTransport = {
      ...state.currentForfaitTransport,
      tranche
    }
    state.trancheSelected = tranche
  },
  [types.SET_PROPERTY_FORFAIT_TRANSPORT](state, { propName, property }) {
    state.currentForfaitTransport = {
      ...state.currentForfaitTransport,
      [propName]: property
    }
  },
  [types.ADD_TRANCHE_FORFAITS_TRANSPORT](state, tranche) {
    state.tranchesOptions = [
      ...state.tranchesOptions,
      tranche
    ]
  },
  [types.ADD_FORFAIT_TRANSPORT](state, currentForfait) {
    state.forfaitsTransport = {
      ...state.forfaitsTransport,
      [currentForfait.id]: currentForfait
    }
  },
  [types.DELETE_FORFAIT_TRANSPORT](state, currentForfaitId) {
    delete state.forfaitsTransport[currentForfaitId]
    state.forfaitsTransport = {
      ...state.forfaitsTransport
    }
  },
  [types.UPDATE_FORFAIT_TRANSPORT](state, currentForfait) {
    state.forfaitsTransport = {
      ...state.forfaitsTransport,
      [currentForfait.id]: currentForfait
    }
  }
}

const actions = {
  async initForfaitsTransport({ state, commit }) {
    const [
      forfaitsTransport,
      zonesOptions,
      categoriesOptions,
      tranchesOptions
    ] = await Promise.all([
      getForfaitsTransport(),
      getZones(),
      getRootCategories(),
      getTranches()
    ])

    const forfaitsWrapper = {
      forfaitsTransport,
      zonesOptions,
      categoriesOptions,
      tranchesOptions
    }
    commit(types.SET_FORFAITS_TRANSPORT, forfaitsWrapper)
  },
  setTranche({ commit }, tranche) {
    commit(types.SET_TRANCHE_FORFAIT_TRANSPORT, tranche)
  },
  setAgence({ commit }, agence) {
    commit(types.SET_AGENCE_FORFAIT_TRANSPORT, agence)
  },
  setForfaitProperty({ commit }, { propName, property }) {
    commit(types.SET_PROPERTY_FORFAIT_TRANSPORT, { propName, property })
  },
  async createTranche({ commit }, localTranche) {
    const remoteTranche = await postTranche(localTranche)
    commit(types.ADD_TRANCHE_FORFAITS_TRANSPORT, remoteTranche)
    commit(types.SET_TRANCHE_FORFAIT_TRANSPORT, remoteTranche)
  },
  async createForfaitTransport({ commit, state }) {
    const forfaitRemote = await postForfaitTransport(state.currentForfaitTransport)
    commit(types.ADD_FORFAIT_TRANSPORT, forfaitRemote)
  },
  async deleteForfaitTransport({ commit }, forfaitId) {
    await deleteForfaitTransport(forfaitId)
    commit(types.DELETE_FORFAIT_TRANSPORT, forfaitId)
  },
  async updateForfaitTransport({ commit }, forfait) {
    const forfaitRemote = await postForfaitTransport(forfait)
    commit(types.UPDATE_FORFAIT_TRANSPORT, forfaitRemote)
  },
  openTrancheForm({ dispatch }) {
    dispatch('openModal', { type: constants.TRANCHE_FORFAIT_TRANSPORT_MODAL })
  }
}

const getters = {
  forfaitsTransport: state => {
    const { forfaitsTransport } = state
    if (forfaitsTransport === undefined || forfaitsTransport === null || Object.keys(forfaitsTransport).length === 0) return null
    const forfaitsView = { agences: {}, sans_agence: { zones: {},tranches: {} } }
    Object.keys(state.forfaitsTransport).forEach(function (key) {
      let forfait = state.forfaitsTransport[key]
      if (!forfait.tranche) {
        forfait.tranche = {
          'id': 'empty',
          'libelle': 'Tranche incorrecte'
        }
      }
      let tranche = {
        'type': 'tranche',
        'id': forfait.tranche.id,
        'label': forfait.tranche.libelle,
        'start': forfait.tranche.debut_tranche,
        'is_unique': forfait.tranche.tranche_unique,
        'step': forfait.tranche.tranche_interval,
        'forfait': {
          'id': forfait.id,
          'montant': forfait.montant,
          'franco': forfait.franco
        }
      }
      if (forfait.hasOwnProperty('agence')) {
        let newProperty = forfaitsView['agences']
        if (!forfait.agence) {
          forfait.agence = {
            'code_agence': 'empty',
            'libelle_agence': 'Agence incorrecte'
          }
        }
        if (!newProperty.hasOwnProperty(forfait.agence.code_agence)) {
          newProperty[forfait.agence.code_agence] = {
            'type': 'agence',
            'id': forfait.agence.code_agence,
            'label': forfait.agence.libelle_agence,
            'zones': {},
            'tranches': {}
          }
        }

        newProperty = newProperty[forfait.agence.code_agence]
        populateAgence(forfait, newProperty, tranche)
      } else {
        let newProperty = forfaitsView['sans_agence']
        populateAgence(forfait, newProperty, tranche)
      }
    })

    return forfaitsView
  },
  zonesOptions: state => state.zonesOptions,
  categoriesOptions: state => state.categoriesOptions,
  tranchesOptions: state => state.tranchesOptions,
  currentForfaitTransport: state => state.currentForfaitTransport,
  trancheSelected: state => state.trancheSelected
}

function populateAgence(forfait, newProperty, tranche) {
  if (forfait.hasOwnProperty('zone')) {
    if (!forfait.zone) {
      forfait.zone = {
        'id': 'empty',
        'libelle': 'Zone incorrecte'
      }
    }
    newProperty = newProperty['zones']
    if (!newProperty.hasOwnProperty(forfait.zone.id)) {
      newProperty[forfait.zone.id] = {
        'type': 'zone',
        'id': forfait.zone.id,
        'label': forfait.zone.libelle,
        'categories': {},
        'tranches': {}
      }
    }
    const formatCategoryLabel = (label) => {
      return label.toLowerCase()
    }
    if (forfait.hasOwnProperty('categorie')) {
      if (!forfait.categorie) {
        forfait.categorie = {
          'code_famille': 'empty',
          'libelle_famille': 'Plan de vente incorrect'
        }
      }
      newProperty = newProperty[forfait.zone.id]['categories']
      if (!newProperty.hasOwnProperty(forfait.categorie.code_famille)) {
        newProperty[forfait.categorie.code_famille] = {
          'type': 'categorie',
          'id': forfait.categorie.code_famille,
          'label': formatCategoryLabel(forfait.categorie.libelle_famille),
          'tranches': {}
        }
      }
      newProperty = newProperty[forfait.categorie.code_famille]['tranches']
      if (!newProperty.hasOwnProperty(forfait.tranche.id)) {
        newProperty[forfait.tranche.id] = tranche
      }
    } else {
      newProperty = newProperty[forfait.zone.id]['tranches']
      if (!newProperty.hasOwnProperty([forfait.tranche.id])) {
        newProperty[forfait.tranche.id] = tranche
      }
    }
  } else {
    newProperty = newProperty['tranches']
    if (!newProperty.hasOwnProperty([forfait.tranche.id])) {
      newProperty[forfait.tranche.id] = tranche
    }
  }
}

export default { state, mutations, actions, getters }
